import { normalizeSite } from "./SiteConfig";
import { getLuminance } from "polished";
import { merge } from "lodash-es";

// theme start
export const theme = {
  colors: {
    primary: "#0C68F1",
    isLight: false,
    primaryText: "#333"
  },
  darkMode: false,
  shadows: {
    raised1: "1px 2px 3px rgba(0, 0, 0, 0.1)",
    raised2: "1px 5px 10px rgba(0, 0, 0, 0.1)",
    siteHeader: "0px 3px 4px rgba(0, 0, 0, 0.1)"
  },
  typography: {
    direction: "LTR",
    sansFamily: `"Noto Sans", sans-serif;`,
    serifFamily: `"Noto Serif", sans-serif;`
  }
};

export const darkTheme = {
  ...theme,
  darkMode: true,
  colors: {
    ...theme.colors,
    primaryText: "white"
  }
};
// theme end

export const themeFromSiteConfig = (rawSite: object) => {
  if (!rawSite) throw new Error("site not found");

  const site = normalizeSite(rawSite);
  const siteTheme = {
    colors: {
      primary: site.primaryColor,
      secondary: site.secondaryColor,
      isLight: getLuminance(site.primaryColor) > 0.7
    },
    typography: {
      direction: site.scriptDirection
    }
  };

  return merge({ ...theme }, siteTheme);
};
